import { Dropdown, NavDropdown, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import PropTypes from 'prop-types'
import { HashLink } from 'react-router-hash-link'
import { logout } from '../../actions/login'
import { CustomerStatusEnum } from '../../Enum/CustomerStatusEnum'
import { getPath } from '../../MultilingualRouter/MultilingualRouter'
import Pages from '../../Enum/Pages'

const UserMenu = ({ content, path }) => {
  const dispatch = useDispatch()
  const customerData = useSelector((state) => state.customerAccount?.customer)
  const lang = useSelector((state) => state.lang.lang)
  const customerDetail = customerData?.attributes?.customerDetail
  const status = customerData?.attributes?.customerDetail?.amlStatus?.status
  const navigate = useNavigate()

  const getStatusClass = () => {
    switch (status) {
      case CustomerStatusEnum.Inactive:
        return 'inactive'

      case CustomerStatusEnum.NotVerified:
        return 'not-verified'

      case CustomerStatusEnum.Basic:
        return 'basic'

      case CustomerStatusEnum.Plus:
        return 'plus'

      default:
        return ''
    }
  }

  const getStatusName = () => {
    switch (status) {
      case CustomerStatusEnum.Inactive:
        return content?.userStatus?.inactive

      case CustomerStatusEnum.NotVerified:
        return content?.userStatus?.notVerified

      case CustomerStatusEnum.Basic:
        return content?.userStatus?.basic

      case CustomerStatusEnum.Plus:
        return content?.userStatus?.plus

      default:
        return ''
    }
  }

  const showNavItemFlag = (urlId) => {
    if (urlId === Pages.verificationPage
      && (status === CustomerStatusEnum.NotVerified || status === CustomerStatusEnum.Plus)) {
      return false
    }
    return true
  }

  return (
    <Dropdown align="end">
      <Dropdown.Toggle variant="primary" className="header-top-bar-toggle ms-3 user-menu-link">
        <i className="material-icons">account_circle</i>
      </Dropdown.Toggle>
      <Dropdown.Menu renderOnMount className="user-menu bg-light">
        <div className="user-menu-header bg-light d-flex align-items-center border-bottom">
          <i className="material-icons user-avatar-con display-4 ms-3 text-primary">account_circle</i>
          <div className="col py-2">
            <p className="mb-0 h6">{`${customerDetail?.lastName} ${customerDetail?.firstName}`}</p>
            <small className={`status-badge status-${getStatusClass()}-bg`}>{getStatusName()}</small>
            <div className="d-flex align-items-center justify-content-between">
              <small className="text-muted fw-bold">{customerData?.id}</small>
              <Button
                variant="light"
                onClick={() => dispatch(logout(lang, navigate))}
                className="btn btn-sm btn-link fw-bold"
              >
                {content.logout}
              </Button>
            </div>
          </div>
        </div>
        {content.logedLinks?.map((userLink, index) => {
          const linkPath = userLink.link || getPath(userLink.linkId?.urlId)
          return (
            <div key={`${userLink.id}`}>
              {!userLink.link && !userLink.linkId ? (
                <div
                  className="bg-light px-2 pb-2 pt-3 border-bottom small text-uppercase text-muted"
                  style={{
                    borderTop: '.25rem #dee2e6 solid',
                    marginBottom: '-1px'
                  }}
                >
                  {userLink.title}
                </div>
              ) : (showNavItemFlag(userLink.linkId?.urlId)
                && (
                  <NavDropdown.Item
                    to={linkPath}
                    className={`p-0 d-flex w-100 align-items-center${path === linkPath ? ' bg-primary text-white' : ''}`}
                    active={path === linkPath}
                    as={HashLink}
                  >
                    <i className={`material-icons h3 mb-0 mx-3  ${path === linkPath ? 'text-white' : 'text-primary'}`}>
                      {userLink.icon}
                    </i>
                    <span className={`col py-2 ps-0 ${index > 0 && path !== linkPath && 'border-top'}`}>
                      {userLink.title}
                    </span>
                  </NavDropdown.Item>
                )
              )}
              {userLink.hasDivider && <NavDropdown.Divider className="user-menu-divider" />}
            </div>
          )
        })}
      </Dropdown.Menu>
    </Dropdown>
  )
}

UserMenu.propTypes = {
  content: PropTypes.instanceOf(Object).isRequired,
  path: PropTypes.string.isRequired
}

export default UserMenu
